import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useAnalytics = (measurementId = "G-K0DTY72G7G") => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", measurementId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, measurementId]);
};

export default useAnalytics;
